import React from "react";

import display from "@iconify/icons-bi/display";
import moon from "@iconify/icons-bi/moon";
import sun from "@iconify/icons-bi/sun";
import { Icon } from "@iconify/react/dist/offline";

import { Button } from "src/components/ui/button";
import { cn } from "src/lib/utils";

import type { ThemeChoice } from "./user-menu-utils";

const THEME_OPTIONS: Array<{
  id: ThemeChoice;
  icon: typeof sun;
  label: string;
}> = [
  { id: "light", icon: sun, label: "Light" },
  { id: "dark", icon: moon, label: "Dark" },
  { id: "system", icon: display, label: "System" },
];

interface ThemeToggleProps {
  theme: ThemeChoice;
  onThemeChange: (choice: ThemeChoice) => void;
}

const ThemeToggle = ({
  theme,
  onThemeChange,
}: ThemeToggleProps): React.ReactElement => {
  return (
    <div className="flex bg-surface-2 border border-border/50 rounded-md p-0.5">
      {THEME_OPTIONS.map((opt) => {
        const active = theme === opt.id;
        return (
          <Button
            key={opt.id}
            variant="ghost"
            onClick={() => onThemeChange(opt.id)}
            className={cn(
              "gap-[5px] px-2.5 py-1 rounded-[5px] text-[11.5px] font-medium h-auto",
              active
                ? "bg-surface-3 text-foreground shadow-sm"
                : "text-text-tertiary"
            )}
          >
            <Icon
              icon={opt.icon}
              width={11}
              height={11}
              className={active ? "text-foreground" : "text-text-tertiary"}
            />
            {opt.label}
          </Button>
        );
      })}
    </div>
  );
};

export default ThemeToggle;
